<script>
import Layout from "../../../router/layouts/print";

/**
 * Screen component
 */
/* eslint-disable no-console */

export default {
  components: { Layout },
  data() {
    return {
      contract: null,
      saleDates: [],
      registerDates: [],

      partners: []
    };
  },
  mounted() {},

  watch: {
    data: function(newVal) { 
      this.contract = newVal;
      this.saleDates = this.contract.sale_date_show.split("-");
      this.registerDates = this.contract.register_date_show.split('-');
      this.partners = this.contract.partners;
    }
  },

  methods: {

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    }

  },

  props: {
    data: null,
  }

};
</script>
<template>
  <Layout>
        <center>
          <div class="col center c-color box-a4 frame-bor">
          
            <p><br/></p>
            <p class="khm title l4">ព្រះរាជាណាចក្រកម្ពុជា</p>
            <p class="khm h5 l4">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
            <p class="top-0">
              <img src="../../../assets/images/3symbol.svg" style="width: 150px;"/>
            </p>
            <p><br/><br/><br/><br/></p>
            <img src="@/assets/images/h-logo.svg" alt height="120" />
            <p><br/></p>
            <p class="khm sub-title l3">ក្រុមហ៊ុនលំនៅឋាន <span class="g-color">អេចស៊ី</span> ឯ.ក</p>
            <p class="enb sub-title l3">LOMNOV THAN <span class="g-color">HC</span> CO., LTD</p>
            <p class="top-3">
              <img src="@/assets/images/3symbol.svg" style="width: 150px;margin-top: 10px; margin-bottom: 40px;"/>
            </p>

            <p><br/><br/></p>
            <p class="khm h5 l5">កិច្ចព្រមព្រៀងលក់-ទិញ លំនៅឋាន</p>
            <p class="khm h5 l5">គម្រោង: លំនៅឋាន អេច សែនសុខ</p>
            <p class="khm h5 l5">យូនីតលេខ <span class="enb">{{contract && contract.property}}</span> ជាន់ទី: <span class="enb">{{contract && ('0' + contract.floor).slice(-2)}}</span></p>

            <p><br/><br/><br/><br/></p>
            <p class="khm small-text">ថ្ងៃទី <span class="enb">{{saleDates[0]}}</span> ខែ {{saleDates[1]}} ឆ្នាំ <span class="enb">{{saleDates[2]}}</span> </p>
            <p class="khm small-text">លេខកូដ: <span class="enb">{{contract && contract.contract_number}}</span></p>
            <p><br/><br/><br/><br/><br/></p>



            <p class="">
              <img src="@/assets/images/bellow.svg" style="width: 100px;"/>
            </p>
            <p class="kh doc-footer"><b>អាសយដ្ឋានដីឡូតិ៍លេខៈ</b> 742 ផ្លូវលេខៈ 1952 ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
            <p class="kh doc-footer"><b>ទូរស័ព្ទលេខៈ</b> <span class="enb"> 092 926 688 | 098 926 688 | 089 626 689 | 086 626 689</span></p>
            <p class="en doc-footer"><b>Email:</b> info@h-residence.net|sales@h-residence.net|Facebook: Residence H Cambodia</p>
          
          </div>
          <div class="col dblack box-a4-long kh">
            <p class="khm title l3" style="margin-top: 0.2cm;">ព្រះរាជាណាចក្រកម្ពុជា</p>
            <p class="khm h5 l4">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
            <p class="top-0">
              <img src="../../../assets/images/3symbol.svg" style="width: 150px;"/>
            </p>
            <p class="khm sub-title top3">កិច្ចព្រមព្រៀងលក់-ទិញ លំនៅឋាន</p>
            <p class="en sub-title" style="margin-top: -20px; font-size: 12pt;">~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
  
            <table width="100%" class="doc-content top text-justify">
              <tr>
                <td width="16%"><p>&nbsp;</p></td>
                <td width="84%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ធ្វើឡើងរវាងៈ</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  <span class="khm">ក្រុមហ៊ុនលំនៅឋាន អេចស៊ី ឯ.ក</span> តំណាងដោយលោកៈ <span class="khm">លឹម ទ្រី</span> កាន់អត្តសញ្ញាណប័ណ្ណសញ្ជាតិខ្មែរលេខៈ 011335234 ចុះថ្ងៃទី 24-01-2019 ការិយាល័យកណ្តាលដីឡូតិ៍លេខៈ 742 ផ្លូវលេខៈ 1952 ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ ។  ទូរស័ព្ទលេខៈ 092 926 688 | 098 926 688 | 089 626 689 | 086 626 689 Email: sales@h-residence.net <b>(ហៅថាភាគី “ក”)</b> ។
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ជាមួយនិងៈ</p>
                </td>
                <td>
                  <p style="text-align: justify;">លោក/លោកស្រីៈ <span class="khm">{{contract && contract.name}}</span> ភេទៈ {{contract && contract.sex}} ជនជាតិៈ {{contract && contract.nationality}} សញ្ជាតិៈ {{contract && contract.nationality}}
                  កាន់អត្តសញ្ញាណប័ណ្ណ / លិខិតឆ្លងដែនលេខៈ {{contract && contract.id_no}} ចុះថ្ងៃទីៈ {{contract && contract.id_date_show}} ។
                    <span  v-for="(partner, index) in partners" :key="index">
                     និងលោក/លោកស្រីៈ <span class="khm">{{partner.partner_name}}</span> ភេទៈ {{partner.sex}} ជនជាតិៈ {{partner.nationality}} សញ្ជាតិៈ {{partner.nationality}}
                    កាន់អត្តសញ្ញាណប័ណ្ណ / លិខិតឆ្លងដែនលេខៈ {{partner.partner_id_no}} ចុះថ្ងៃទីៈ {{partner.partner_id_date_show}} ។
                    </span>
                  អាសយដ្ឋានបច្ចុប្បន្នៈ {{contract && contract.address}} ។ ទូរស័ព្ទលេខៈ {{contract && contract.phone_no_1}}  {{contract && contract.phone_no_2}} <b>(ហៅថាភាគី “ខ”)</b> ៕
                  </p>
                </td>
              </tr>
            </table>
            <p><br/></p>
            <P class="khm sub-title-zero underline">ភាគីទាំងពីរបានឯកភាពគ្នាចុះកិច្ចព្រមព្រៀងតាមលក្ខខណ្ឌដូចខាងក្រោម៖</P>
            <table class="doc-content top text-justify">
              <tr>
                <td width="8%"></td>
                <td width="92%"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ 1 កម្មវត្ថុនៃកិច្ចព្រមព្រៀង</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">1.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  ជាកិច្ចព្រមព្រៀងដែលភាគី “ក” យល់ព្រមលក់ និងភាគី “ខ” បានយល់ព្រមទិញខុនដូពីក្រុមហ៊ុន <span class="khm">លំនៅឋាន អេចស៊ី ឯ.ក</span> នៃគម្រោងខុនដូ <span class="khm">“លំនៅឋាន អេច សែនសុខ”</span> យូនីតលេខៈ {{contract && contract.property}} នៅជាន់ទីៈ {{contract && ('0' + contract.floor).slice(-2)}} ទំហំៈ {{contract && formatCurrency(contract.net_size)}}ម៉ែត្រការ៉េ, និងទំហំរួមៈ {{contract && formatCurrency(contract.cross_size)}}ម៉ែត្រការ៉េ, មានទីតាំងស្ថិតនៅដីឡូតិ៍លេខៈ 1255 ផ្លូវលេខៈ 1978 ភូមិទំនប់ សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ ។
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ 2 តម្លៃខុនដូ</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    2.1
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  ភាគី “ក” យល់ព្រមលក់ខុនដូ ដែលមានចែងក្នុងប្រការ1 (ចំណុច1.1) ឱ្យទៅភាគី “ខ” ក្នុងតម្លៃៈ <span class="number">{{contract && formatCurrency(contract.price, 'USD', '')}}</span>({{contract && contract.price_show}}ដុល្លារអាមេរិក) ។ បញ្ចុះតម្លៃរួចនៅសល់ៈ<span class="number">{{contract && formatCurrency(contract.sale_price, 'USD', '')}}</span>({{contract && contract.sale_price_show}}ដុល្លារអាមេរិក) ។
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ 3 ការទូទាត់ប្រាក់</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.1
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  ប្រាក់ថ្លៃទិញខុនដូចំនួនៈ <span class="number">{{contract && formatCurrency(contract.sale_price, 'USD', '')}}</span> ({{contract && contract.sale_price_show}}ដុល្លារអាមេរិក) ភាគី “ខ” ត្រូវប្រគល់ជូនភាគី “ក” ឱ្យបានគ្រប់ចំនួន តាមកាលវិភាគបង់ប្រាក់ដែលភ្ជាប់ជាឧបសម្ព័ន្ធនៃកិច្ចព្រមព្រៀងនេះ ។ ក្រោយពេលបង់ដំណាក់កាលចប់ អតិថិជនអាចបង់រំលស់ជាមួយម្ចាស់គម្រោងបានដោយគិតអត្រាការប្រាក់ ១%(មួយភាគរយ)ក្នុងមួយខែ។
                </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.2
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងករណី ភាគី “ខ” យឺតយ៉ាវបង់ប្រាក់ជូន ភាគី “ក” លើសពី៣ថ្ងៃ ភាគី “ខ” យល់ព្រមបង់ប្រាក់ពិន័យជូន ភាគី “ក”
                    ចំនួនៈ0.5%(សូន្យចុចប្រាំភាគរយ)ក្នុង1ថ្ងៃនៃចំនួនទឹកប្រាក់ដែលត្រូវបង់ការយឺតយ៉ាវនេះមិនឱ្យលើសរយៈពេល60ថ្ងៃឡើយគិតពីថ្ងៃដែលបានខកខានបង់ប្រាក់។ 
                    ក្នុងករណីដែលភាគី “ខ” យឺតលើសពី60ថ្ងៃហើយ ភាគី “ខ” មិនមានការឆ្លើយតប ឫ មិនមានការចរចារ ជាមួយភាគី “ក” តាមការជូនដំណឹង នោះប្រាក់ដែលបានបង់កន្លងមកភាគី “ខ” មិនទាមទារយកវិញឡើយ ហើយភាគី “ខ” នឹងប្រគល់បន្ទប់ខុនដូខាងលើជូនក្រុមហ៊ុនវិញ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.3
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី "ខ" មានសិទ្ធិបង់កាត់ប្រាក់ដើម ឬបង់ផ្តាច់លើកិច្ចព្រមព្រៀងនេះបានគ្រប់ពេលវេលា ក្នុងកំឡុងពេលកំពុងបង់រំលស់ជាមួយភាគី "ក" ដោយមិនមានការផាកពិន័យឡើយ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.4
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    នៅពេលអគារខុនដូបានសាងសង់រួចរាល់ជាស្ថាពរ ភាគី “ខ” ត្រូវបង់ប្រាក់ដើមឱ្យបានយ៉ាងតិចបំផុត10% (ដប់ភាគរយ) នៃចំនួនទឹកប្រាក់ថ្លៃទិញយូនីតខុនដូ ដូចមានចែងក្នុងប្រការ2 ចំណុច 2.1 ទើបភាគី “ក” ផ្តល់សិទ្ធិឱ្យចូលរស់នៅក្នុងខុនដូបាន។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.5
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    នៅពេលខុនដូសាងសង់រួចរាល់ ភាគី “ខ”  ដែលកំពុងបង់រំលស់ជាមួយភាគី “ក”  យល់ព្រមផ្ទេរការបង់ប្រាក់នេះទៅប្រើប្រាស់កម្ចីឥណទានរបស់ធនាគារវិញតាមរយៈការណែនាំធនាគារជាដៃគូរបស់ភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.6
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ដើម្បីទទួលបានឥណទានពីធនាគារ ភាគី “ខ” យល់ព្រមផ្ទេរកាត់ឈ្មោះប័ណ្ណសហកម្មសិទ្ធិពីភាគី “ក” មកភាគី “ខ” ឱ្យបានរួចរាល់ ដោយសោហ៊ុយចំណាយជាបន្ទុករបស់ភាគី “ខ” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.7
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” យល់ព្រមចំណាយលើថ្លៃសេវាផ្សេងៗមួយចំនួនទៀតរបស់ធនាគារ ដូចជាថ្លៃសេវាដាក់បន្ទុកលើប័ណ្ណកម្មសិទ្ធិ សេវាមេធាវី សេវាធានារ៉ាប់រង សេវាវាយតម្លៃលើអចលនទ្រព្យ សេវាឥណទានកម្ចីរបស់ធនាគារ ។
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2">
                  <p class="khm">
                    ប្រការ 4 ការសាងសង់
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” នឹងសាងសង់អគារខុនដូ <span class="khm">“លំនៅឋាន អេច សែនសុខ”</span> ក្នុងរយៈពេល30ខែ (និងរយៈពេលអនុគ្រោះ06ខែ) ដោយគិតចាប់ពីថ្ងៃទី០1 ខែមករា ឆ្នាំ2022 តទៅ ។ ប្រសិនបើការសាងសង់អគារខុនដូរួចរាល់មុនកាលកំណត់ក្នុងកិច្ចព្រមព្រៀងនេះ ភាគី “ក” មានកាតព្វកិច្ចជូនដំណឹងទៅភាគី “ខ” ដើម្បីមកពិនិត្យមើលខុនដូរបស់ខ្លួន និងធ្វើលិខិតទទួលសិទ្ធិចូលស្នាក់នៅ ។ ចំណែកភាគី “ខ” ត្រូវអនុវត្តតាមការជូនដំណឹងរបស់ភាគី “ក” និងបង់ប្រាក់ថ្លៃទិញខុនដូដែលនៅសល់ជូនភាគី “ក” តាមកាលវិភាគបង់ប្រាក់ដែលបានភ្ជាប់ក្នុងឧបសម្ព័ន្ធនៃកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.2</p>
                </td>
                <td>
                  <p>ទ្រង់ទ្រាយ និងគ្រឿងសម្ភារៈដែលត្រូវបំពាក់ជូនខុនដូនេះរួមមាន៖<br/>
                    - អំពូលភ្លើង តាមស្តង់ដារបស់ក្រុមហ៊ុន ។<br/>
                    - មានរ៉ូប៊ីនេទឹក នៅវេរ៉ង់ដា ។<br/>
                    - បន្ទប់ទឹកខណ្ឌផ្ទាំងកញ្ចក់កន្លែងងូតទឹក ផ្កាឈូក ឡាវ៉ាបូជាប់ជញ្ជាំង កញ្ចក់ឆ្លុះមុខ បង្គន់ កង្ហារបឺតក្លិន ។<br/>
                    - ឥដ្ឋការ៉ូ 60x60សង់ទីម៉ែត្រ ដែលនាំចូលពីប្រទេសចិន ។<br/>
                    - ពិដានម្នាងសិលា ជញ្ជាំងលាបថ្នាំ ទ្វារតាមស្តង់ដាក្រុមហ៊ុន និងបង្អួចកញ្ចក់ ។<br/>
                    - តបណ្តាញទឹក និងអគ្គិសនី តាមស្តង់ដាក្រុមហ៊ុន ។<br/>
                    - តុចង្ក្រានបិទម៉ាប មានចង្ក្រានអគ្គិសនី1គ្រឿង ម៉ាស៊ីនបឺតផ្សែង1 ស៊ីងលាងចាន និងទូដាក់សម្ភារៈផ្ទះបាយ លើ/ក្រោម ។<br/>
                    - មានបណ្តាញខ្សែ សម្រាប់ទូរទស្សន៍ខ្សែកាប និងអ៊ីនធើណេត បង្កប់ក្នុងជញ្ជាំង ។<br/>
                    - មានបំពាក់ខ្សែភ្លើង ទុយោទឹក និងទុយោស្ពាន់សម្រាប់ម៉ាស៊ីនត្រជាក់ ។<br/>
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.3</p>
                </td>
                <td>
                  <p>
                    ភាគី “ក” ត្រូវតបណ្តាញអគ្គិសនី និងបណ្តាញទឹកជូនភាគី “ខ” ដោយថ្លៃសោហ៊ុយជាបន្ទុករបស់ភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.4</p>
                </td>
                <td>
                  <p>
                    ក្នុងករណីភាគី “ខ” ចង់ជួសជុល ឬកែប្រែទ្រង់ទ្រាយខុនដូ ត្រូវមានការឯកភាពពីភាគី “ក” ។ ការកែប្រែ ឬជួសជុលខុនដូ ធ្វើទៅបានលុះត្រាតែមិនប៉ះពាល់មូលដ្ឋានគ្រឹះ និងសោភ័ណភាពខាងក្រៅនៃអគារ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.5</p>
                </td>
                <td>
                  <p>
                    ក្នុងករណីចាំបាច់ ភាគី “ក” សុំរក្សាសិទ្ធិកែប្រែប្លង់រចនាសម្ព័ន្ធ និងប្លង់ដេគ័រខាងក្នុងខ្លះៗ ប៉ុន្តែរក្សាទំហំយូនីតខុនដូឱ្យនៅដដែល។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.6</p>
                </td>
                <td>
                  <p>
                    ភាគី “ក” ធានាជួសជុលជូនរយៈពេល01ឆ្នាំឥតគិតថ្លៃ លើជម្រាបទឹក ការប្រេះស្រាំជញ្ជាំងក្នុងយូនីតខុនដូរបស់ភាគី “ខ” (គិតចាប់ពីថ្ងៃដែលក្រុមហ៊ុនប្រកាស់សេចក្តីជូនដំណឹងស្តីពីការប្រគល់-ទទួល យូនីតខុនដូតទៅ)។
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2">
                  <p class="khm">
                    ប្រការ 5 ការផ្ទេរសិទ្ធិ
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">5.1</p></td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងកំឡុងពេលសាងសង់ ភាគី “ខ”  អាចលក់ ឬផ្ទេរកិច្ចព្រមព្រៀង លក់-ទិញ ខុនដូនេះបាន ដោយមានការឯកភាពជាលាយ លក្ខណ៍អក្សរពីភាគី “ក”  ហើយភាគី “ខ”  ត្រូវបង់ថ្លៃផ្ទេរឈ្មោះចំនួនៈ <span class="number">USD200</span> (ពីររយដុល្លារអាមេរិក) ជូនភាគី “ក” ។ ភាគីអ្នកទិញបន្ត ឬអ្នកដែលទទួលយកការផ្ទេរកិច្ចព្រមព្រៀងពីភាគី “ខ”  ត្រូវគោរពតាមខ្លឹមសារទាំងស្រុងនៃកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">5.2</p></td>
                <td>
                  <p style="text-align: justify;">
                    នៅពេលអគារខុនដូសាងសង់រួចរាល់ភាគី “ក” នឹងបំបែកប័ណ្ណសហកម្មសិទ្ធិជូនភាគី “ខ” ដោយថ្លៃសោហ៊ុយជាបន្ទុករបស់ភាគី “ក” ។ ភាគី “ក” នឹងជូនដំណឹងជាលាយលក្ខណ៍អក្សរមកភាគី “ខ” រយៈពេល15ថ្ងៃដើម្បីឱ្យភាគី “ខ” មកពិនិត្យនិងទទួលយកខុនដូរបស់ខ្លួន ។ ក្នុងរយៈពេលជូនដំណឹង15ថ្ងៃនេះបើភាគី “ខ” មិនបានឆ្លើយតប ឬមិនបានមកពិនិត្យមើលនោះទេ ចាត់ទុកថាភាគី “ខ” បានឯកភាពទទួលយកហើយ និងបង់ប្រាក់ថ្លៃទិញខុនដូខាងលើជូនភាគី “ក” តាមកាលវិភាគបង់ប្រាក់ដែលបានភ្ជាប់ជាឧបសម្ព័ន្ធនៃកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">5.3</p>
                </td>
                <td>
                  <p>
                    ក្រោយពេលភាគី “ខ” បានទូទាត់ថ្លៃទិញខុនដូជូនភាគី “ក” គ្រប់ចំនួនហើយ ភាគី “ក” នឹងសហការផ្តឹតមេដៃលើឯកសារផ្ទេរឈ្មោះពីភាគី “ក” ទៅភាគី “ខ” ដោយថ្លៃសោហ៊ុយលើការផ្ទេរសិទ្ធិនេះជាបន្ទុករបស់ភាគី “ខ” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">5.4</p>
                </td>
                <td>
                  <p>
                    ភាគី “ក” ធានាអះអាងថាខុនដូដែលបានលក់ជូនភាគី “ខ” ក្នុងកិច្ចព្រមព្រៀងនេះពិតជារបស់ខ្លួន ពុំមានលក់ដូរ ជួល ផ្ទេរសិទ្ធិ ធ្វើអំណោយ ជាប់បញ្ចាំ ជាប់ការហាមឃាត់ ឬជាប់បន្ទុកណាមួយឡើយ ។
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2"><p class="khm">ប្រការ 6 ការបង់ពន្ធ និង ថ្លៃសេវាកម្ម</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">6.1</p></td>
                <td>
                  <p style="text-align: justify;">
                  នៅក្នុងកំឡុងពេលសាងសង់ និងមុនពេលប្រគល់ខុនដូជូនភាគី “ខ” ចំណាយលើការបង់ពន្ធជូនរដ្ឋ និងថ្លៃសេវាផ្សេងៗជាបន្ទុករបស់ភាគី “ក” ។ ប៉ុន្តែបន្ទាប់ពីបានប្រគល់ និងទទួលសិទ្ធិចូលស្នាក់នៅរួចរាល់ តទៅចំណាយលើការបង់ពន្ធលើអចលនៈទ្រព្យ និងថ្លៃសេវាផ្សេងៗទៀតជាបន្ទុករបស់ភាគី “ខ” ទាំងស្រុង ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">6.2</p></td>
                <td>
                  <p style="text-align: justify;">
                  គិតចាប់ពីថ្ងៃបានទទួលសិទ្ធិចូលស្នាក់នៅ ភាគី “ខ” សន្យាថាយល់ព្រមឱ្យភាគី “ក” ឬ(ក្រុមហ៊ុនដែលកំណត់ដោយភាគី “ក”) ទទួលខុសត្រូវលើការគ្រប់គ្រងលើអគារខុនដូនេះទាំងស្រុង ។ ភាគី “ខ” មានកាតព្វកិច្ចបង់ថ្លៃសេវាប្រចាំខែចំនួនៈ <span class="number">USD0.50</span> 
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli"></p></td>
                <td>
                  <p style="text-align: justify;">
                  (សូន្យចុចប្រាំដុល្លារអាមេរិក) ក្នុង1ម៉ែត្រការ៉េ នៃទំហំរួមនៃយូនីត ដែលជាបទដ្ឋានគោលនៃការគណនា ។ សេវាកម្មនេះរួមមានដូចជា៖ ភ្លើង បំភ្លឺផ្លូវ អនាម័យ សន្តិសុខ ជណ្តើយន្ត ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">6.3</p></td>
                <td>
                  <p style="text-align: justify;">
                    ថ្លៃសោហ៊ុយប្រើប្រាស់ចរន្តអគ្គិសនី និងទឹកជាបន្ទុករបស់ភាគី “ខ” ។ ភាគី “ខ” យល់ព្រមបង់ថ្លៃប្រើប្រាស់ចរន្តអគ្គិសនីប្រចាំខែចំនួនៈ <span class="number">USD0.25</span> (សូន្យចុចម្ភៃប្រាំដុល្លារអាមេរិក) ក្នុង1គីឡូវ៉ាត់ម៉ោង និងថ្លៃប្រើប្រាស់ទឹកប្រចាំខែចំនួនៈ <span class="number">3,000</span>រៀល (បីពាន់រៀល) ក្នុង1 ម៉ែត្រគូបជូនភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">6.4</p></td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងករណីភាគី “ខ” មានរថយន្ត ហើយប្រើប្រាស់ចំណតក្នុងអគារខុនដូ ភាគី “ខ” ត្រូវបង់ថ្លៃចំណតជូនភាគី “ក” ចំនួនៈ <span class="number">USD40</span> (សែសិបដុល្លារអាមេរិក) ក្នុង1ខែសម្រាប់1ចំណត ចំពោះម៉ូតូផ្តល់ជូន2ចំណត សម្រាប់1យូនីតដោយមិនគិតថ្លៃ ។ យោងលើស្ថានភាពសេដ្ឋកិច្ចជាក់ស្តែង ភាគី “ក” ឬ (ក្រុមហ៊ុនដែលកំណត់ដោយភាគី “ក”) មានសិទ្ធិក្នុងការកែប្រែតម្លៃនេះបាន ដោយជូនដំណឹងជាសាធាណៈរយៈពេល1ខែជាមុន ។
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr><td colspan="2"><p class="khm">ប្រការ 7 ការប្រើប្រាស់បន្ទប់ខុនដូ</p></td></tr>
              <tr>
                <td class="right"><p class="khli">7.1</p></td>
                <td>
                  <p style="text-align: justify;">
                    គិតចាប់ពីថ្ងៃបានទទួលសិទ្ធិចូលស្នាក់នៅភាគី “ខ” សន្យាថាគោរពយ៉ាងម៉ឺងម៉ាត់តាមបទបញ្ជាផ្ទៃក្នុងដែលកំណត់ដោយភាគី “ក” ឬ(ក្រុមហ៊ុនដែលកំណត់ដោយភាគី “ក”) មានដូចជា៖សណ្តាប់ធ្នាប់ សុវត្ថិភាព អនាម័យ ហាមចិញ្ចឹមសត្វ (ឆ្កែ-ឆ្មា-បក្សី និងសត្វផ្សេងៗ ទៀត) ហាមស្រែកឡូឡាខ្លាំងៗ ការបំពុលបរិស្ថាន មិនអនុញ្ញាតឱ្យនាំចូលអាវុធជាតិផ្ទុះខុសច្បាប់ ហាមជួញដូរនិងប្រើប្រាស់គ្រឿងញៀន មិនអនុញ្ញាតឱ្យបើកបនល្បែងគ្រប់ប្រភេទ ហាងលក់ទំនិញ ឬបើកជាក្រុមហ៊ុន គឺសំរាប់តែការស្នាក់នៅប៉ុណ្ណោះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">7.2</p></td>
                <td>
                  <p style="text-align: justify;">
                    ប្រសិនបើភាគី “ខ” ជួលខុនដូរបស់ខ្លួនទៅឱ្យអតិថិជនផ្សេង ភាគី “ខ” ត្រូវជូនដំណឹងមកភាគី “ក” និងផ្តល់កិច្ចសន្យា ជួល1ច្បាប់ ព្រមទាំងអត្តសញ្ញាណអ្នកជួលនោះមកឱ្យភាគី “ក” មុនពេលអនុញ្ញាតឱ្យអ្នកជួលចូលស្នាក់នៅ ។ ហើយភាគី “ខ” ត្រូវធានាថាអ្នកជួលនោះ នឹងគោរពអនុវត្តតាមប្រការទាំងឡាយដែលមានចែងក្នុងកិច្ចព្រមព្រៀងនេះ ប្រសិនបើអ្នកជួលនោះមិនបានគោរពតាម ភាគី “ខ” ជាអ្នកទទួលខុសត្រូវទាំងស្រុងក្នុងការដោះស្រាយរាល់បញ្ហាដែលកើតមានឡើង ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">7.3</p></td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” មិនត្រូវកែប្រែរចនាសម្ព័ន្ធ និងសោភ័ណភាពយូនីតខុនដូផ្នែកខាងក្រៅបានឡើយ ។ ក្នុងករណីភាគី “ខ” កំពុងជាប់បង់ប្រាក់រំលស់ នោះរចនាសម្ព័ន្ធស្តង់ដាដើមក្នុងផ្ទៃយូនីតខុនដូ នឹងមិនត្រូវបានអនុញ្ញាតឱ្យកែប្រែ ឬផ្លាស់ប្តូរជាដាច់ខាត ។
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr><td colspan="2"><p class="khm">ប្រការ 8 ការដោះស្រាយវិវាទ</p></td></tr>
              <tr>
                <td class="right"><p class="khli">8.1</p></td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងករណីមានវិវាទកើតឡើង កិច្ចព្រមព្រៀងនេះ ភាគីទាំងពីរយល់ព្រមគ្នាដោយការចរចា ប៉ុន្តែបើមិនអាចដោះស្រាយតាមវិធីនេះទេ <span class="khm">តុលាការនៃព្រះរាជាណាចក្រកម្ពុជា</span> ជាអ្នកមានសមត្ថកិច្ច ។
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr><td colspan="2"><p class="khm">ប្រការ 9 អវសានបញ្ញាត្តិ</p></td></tr>
              <tr>
                <td class="right"><p class="khli">9.1</p></td>
                <td><p style="text-align: justify;">កិច្ចព្រមព្រៀងនេះជាច្បាប់សម្រាប់គូភាគីអនុវត្ត អាចកែប្រែបានលុះត្រាតែមានការព្រមព្រៀងគ្នារវាងគូភាគីទាំងពីរ។</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.2</p></td>
                <td><p style="text-align: justify;">សុពលភាពនៃកិច្ចព្រមព្រៀងនេះត្រូវបញ្ចប់ នៅពេលដែលគូភាគីបានអនុវត្តកាតព្វកិច្ច ចប់សព្វគ្រប់តាមកិច្ចព្រមព្រៀងនេះ។</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.3</p></td>
                <td><p style="text-align: justify;">គូភាគីបានអាននិងយល់រាល់ខ្លឹមសារពីប្រការ1 ដល់ប្រការ9 ហើយប្តេជ្ញាអនុវត្តតាមកិច្ចព្រមព្រៀងនេះយ៉ាងម៉ឺងម៉ាត់ និងផ្តិតមេដៃលើកិច្ចព្រមព្រៀងនេះទុកជាភស្តុតាង ដោយស្មារតីត្រឹមត្រូវ និងមិនមានការគំរាមកំហែង បង្ខិតបង្ខំពីជនណាម្នាក់ឡើយ ។</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.4</p></td>
                <td><p style="text-align: justify;">កិច្ចព្រមព្រៀងនេះធ្វើឡើងចំនួន2ច្បាប់ មានតម្លៃអនុវត្តស្មើៗគ្នា រក្សាទុកនៅភាគី “ក” ចំនួន1ច្បាប់ និងភាគី “ខ” ចំនួន1ច្បាប់។</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.5</p></td>
                <td><p style="text-align: justify;">កិច្ចព្រមព្រៀងនេះមានចូលជាធរមានសម្រាប់គូភាគីអនុវត្តតាម ចាប់ពីថ្ងៃផ្តិតស្នាមមេដៃនេះតទៅ។</p></td>
              </tr>
              <tr><td colspan="2"><p>&nbsp;</p></td></tr>
              <tr><td colspan="2" class="right"><p>ធ្វើនៅរាជធានីភ្នំពេញ,  ថ្ងៃទី {{saleDates[0]}} ខែ {{saleDates[1]}} ឆ្នាំ {{saleDates[2]}} </p></td></tr>
            </table>
            <br/>
            <table width="100%">
              <tr>
                <td><p style="text-align: center; font-size: 12pt" class="khm">ស្នាមមេដៃ ភាគី “ខ”</p></td>
                <td v-for="(partner, index) in partners" :key="index"><p style="text-align: center; font-size: 12pt" class="khm">ស្នាមមេដៃគូភាគី ភាគី “ខ”</p></td>
                <td><p style="text-align: center; font-size: 12pt" class="khm">ស្នាមមេដៃភាគី “ក”</p></td>
              </tr>
              <tr>
                <td>
                  <p>
                    <br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">{{contract && contract.name}}</p>
                </td>
                <td v-for="(partner, index) in partners" :key="index">
                  <p>
                    <br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">{{partner.partner_name}}</p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">លឹម ទ្រី</p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>